import { jsx as _jsx } from "react/jsx-runtime";
import { Portal } from "@air/primitive-portal";
import { createPopper } from "@popperjs/core";
import { useCallback, useRef } from "react";
export function usePopperContainer(param) {
    let { containerRef, options, usePortal } = param;
    const popperInstance = useRef(null);
    const handlePopper = useCallback((node)=>{
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && node) {
            popperInstance.current = createPopper(containerRef.current, node, options);
        }
    }, [
        containerRef,
        options
    ]);
    // We do not want to rebuild PopperContainer everytime handlePopper changes
    const refreshPopperRef = useRef();
    refreshPopperRef.current = handlePopper;
    const PopperContainer = useCallback((props)=>{
        const content = /*#__PURE__*/ _jsx("div", {
            ref: refreshPopperRef.current,
            ...props
        });
        if (usePortal) {
            return /*#__PURE__*/ _jsx(Portal, {
                children: content
            });
        }
        return content;
    }, [
        usePortal
    ]);
    return {
        popperInstance,
        PopperContainer
    };
}
